import React from 'react';
import { LinearProgress } from '@mui/material';
import { formatNumber } from './units';
import './cerebrumx.scss';

const clampPercent = (value) => Math.min(100, Math.max(0, value));

/** Level bar + percentage, as the reference app draws fuel; the bar is labeled for assistive tech. */
export const PercentCell = ({ value, label, ctx }) => (
	<span className="oem-percent-cell">
		<LinearProgress
			variant="determinate"
			value={clampPercent(value)}
			aria-label={label}
			className="oem-percent-cell-bar"
		/>
		{ctx.t('oemDataModal_percent', { value: formatNumber(value, ctx.locale) })}
	</span>
);
